import { render } from "./AllQuestions.vue?vue&type=template&id=84bf1b94"
import script from "./AllQuestions.vue?vue&type=script&lang=js"
export * from "./AllQuestions.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__